import { render, staticRenderFns } from "./StudentIndex.vue?vue&type=template&id=6a3d27a8&scoped=true"
import script from "./StudentIndex.vue?vue&type=script&lang=js"
export * from "./StudentIndex.vue?vue&type=script&lang=js"
import style0 from "./StudentIndex.vue?vue&type=style&index=0&id=6a3d27a8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d27a8",
  null
  
)

export default component.exports